export default {
  WECHAT_FRIENDS: 'WeChat friends',
  GENERATE_IMAGES: 'Generate image',
  SAVE_PICTURE: 'Save image',
  CANCEL_ACTION: 'Cancel',
  AMAZON_OVERSEAS_PURCHASING_USERS: 'Amazon Global Store User',
  RECOMMEND_EXCELLENT_PRODUCTS_TO_YOU: '· Recommends great products to you ·',
  WECHAT_SHARE_TITLE:
    'Direct import from Global Store, Authentic guarantee, Official customer service, FREE shipping over ¥300',
  WECHAT_IS_NOT_INSTALLED: 'WeChat not installed',
  GENERATE_IMAGES_SUCCEED: 'Image generated successfully',
  SHARE_WECHAT_SUCCEED: 'Share successful',
  SELECT_IMAGES_TO_GENERATE_POST_THRESHOLD:
    'Up to 6 display images can be selected to generate a poster'
};
